<template>
  <div style="width: 100%">
    <b-table
      striped
      hover
      :fields="fields"
      :items="items"
      :per-page="perPage"
      :current-page="currentPage"
      responsive
      :class="black ? 'mf_custom_table_bl' : 'mf_custom_table'"
    >
      <template #head(etf)="data">
        <div class="tbHeader">
          <span class="tbHeader_label">{{ data.label }}</span>
        </div>
      </template>
      <template #head(score1)="data">
        <div class="tbHeader">
          <span class="tbHeader_label">{{ data.label }}</span>
          <ModalInfo
            title="Information sur notre score IMPACT"
            content="<p>Le score IMPACT correspond à l'impact du fond sur notre société.</p>
      <p>
        Plus le score est proche de 100 plus le fond finance des entreprises
        avec un impact positif sur notre environnement.
      </p>
      <p>
        Ce score a été calculé en calculant la moyenne pondéré des scores
        attribués à chacune des entreprises comprises dans l'ETF.
      </p>
      <p>
        Parmi les critères pris en compte dans le calcul des scores, nous
        retrouvons :
      </p>
      <p>
        Critères Environnementaux : Taux d'émission de CO2 / Taux d'utilisation
        ou de production d'énergie verte / Taux de recyclage des déchets /
        Prévention des risques (marées noires,contamination, déjection)
      </p>
      <p>
        Critères Sociaux : Taux de représentation Homme-Femme / Emploi des
        personnes handicapés / Prévention des risques / Formation interne /
        Respect du droit des employés.
      </p>
      <p>
        Critères de Gouvernance : Transparence de la rémunération / Indépendance
        des conseils d'administration / Comité de vérification des comptes /
        Lutte contre la corruption.
      </p>
      <p>
      Pour plus d'information sur ce score, consultez notre article.
      <p>"
          />
        </div>
      </template>
      <template #head(score2)="data">
        <div class="tbHeader">
          <span class="tbHeader_label">{{ data.label }}</span>
          <ModalInfo
            title="Information sur notre score PERFORMEUR 1Y"
            content="<p>
      Le score performeur 1Y (1 an) témoigne de la performance de l'ETF sur 1 an.
    </p>
    <p>Plus le score est élevé plus le couple rendement/risque a été avantageux pour l'investisseur.</p>
    <p>
      - Si le score est supérieur à 1 : La performance de l'ETF a été très bonne. (La performance obtenue a été supérieure au risque pris par l'investisseur.)
    </p>
    <p>
      - Si le score est inférieur à 1 : La performance de l'ETF n'a pas été suffisament élevée pour compenser le risque encourru par l'investisseur.
    </p>
    <p>
    Pour les connaisseurs, notre score performeur 1Y correspond au ratio de sharpe annualisé.
    </p>"
          />
        </div>
      </template>
      <template #head(fees)="data">
        <div class="tbHeader">
          <span class="tbHeader_label">{{ data.label }}</span>
        </div>
      </template>
      <template #head(portefeuille)="data">
        <div class="tbHeader">
          <span class="tbHeader_label">{{ data.label }}</span>
        </div>
      </template>
      <template #cell(etf)="data">
        <span class="tb_col_etf">{{ data.item.name }} </span>
      </template>
      <template #cell(score1)="data">
        <span class="tb_col_score">{{ data.item.esg_score_aggregated }} </span>
      </template>
      <template #cell(score2)="data">
        <span class="tb_col_score">{{
          Math.round(data.item.sharpe_ratio * 100) / 100
        }}</span>
      </template>
      <template #cell(fees)="data">
        <span class="tb_col_score">
          {{ data.item.management_fees }}
        </span>
      </template>
      <template #cell(portefeuille)="data">
        <label class="control control-checkbox">
          <input
            type="checkbox"
            :value="data.item"
            v-model="checked"
            @click="passEvent(data.item)"
            :name="'form[' + data.index + '][select]'"
          />
          <div class="control_indicator"></div>
        </label>
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="my-table"
      :class="black ? 'pagination_bl' : 'pagination_lt'"
    ></b-pagination>
  </div>
</template>
<script>
import ModalInfo from "./ModalInfo.vue";

export default {
  props: ["sector", "asset_class", "platform", "contract", "secs", "black", "securityHasContract", "securityHasPlatform"],
  components: {
    ModalInfo
  },
  data: () => ({
    checked: [],
    perPage: 10,
    currentPage: 1,
    fields: [
      { key: "etf", label: "Nom de l'ETF" },
      { key: "score1", label: "Score impact" },
      { key: "score2", label: "Score performeur" },
      { key: "fees", label: "Frais de gestion (%/an)" },
      { key: "portefeuille", label: "Ajouter au portefeuille" }
    ],
    items: []
  }),

  watch: {
    sector() {
      if(this.asset_class != null && this.sector != null && this.platform != null && this.contract != null)
      {
        let securities = [];

        this.secs.forEach(security => {

          if((security.sector.id == this.sector.id) &&
             (security.asset_class.id == this.asset_class.id))
          {
            security.contracts.forEach(contract => {
              if(contract.id == this.contract.id)
              {
                contract.platforms.forEach(platform => {
                  if(platform.id == this.platform.id)
                  {
                    securities.push(security);
                  }
                });
              }
            });
          }
        });

        return (this.items = securities);
      }
      else
      {
        return [];
      }
    }
  },
  computed: {
    rows() {
      return this.items.length;
    }
  },
  methods: {
    passEvent(data) {
      this.$emit("getChecked", data);
    },
  }
};
</script>
<style lang="scss" scoped>
@import "./resources/sass/_variables.scss";

.pagination_bl {
  justify-content: space-between;
  height: 50px;
  background: $bg_color_bl;
  border-bottom-left-radius: 33px;
  border-bottom-right-radius: 33px;
  align-items: center;

  .page-link {
    margin: 5px;
    background-color: transparent !important;
    border: none;
  }

  // .page-item.disabled .page-link {
  //   pointer-events: none;
  //   background-color: transparent !important;
  //   border-color: transparent;
  // }

  .page-item.disabled .page-link {
    color: #6c757d;
    pointer-events: none;
    cursor: auto;
    background-color: transparent !important;
    border-color: none !important;
  }

  .page-item.active .page-link {
    font-weight: bold;
    background-color: $bg_color_bl !important;
    border-radius: 33px;
    color: $vstr_grey_color !important;
  }

  li {
    button {
      border: none;
      color: $lt_grey_color;
      background: transparent !important;

      &:hover {
        background-color: transparent;
      }
    }
  }
}

.pagination_lt {
  justify-content: space-between;
  height: 50px;
  background: $bg_color;
  border-bottom-left-radius: 33px;
  border-bottom-right-radius: 33px;
  align-items: center;

  .page-link {
    margin: 5px;
    background-color: transparent;
    border: none;
  }

  .page-item.active .page-link {
    font-weight: bold;
    background-color: #d6d6d6;
    border-radius: 33px;
    color: $vstr_grey_color !important;
  }

  li {
    button {
      border: none;
      color: $lt_grey_color;

      &:hover {
        background-color: transparent;
      }
    }
  }
}

.control {
  font-family: arial;
  display: block;
  position: relative;
  padding-left: 30px;
  margin-bottom: 5px;
  margin: auto;
  width: fit-content;
  padding-top: 3px;
  cursor: pointer;
  font-size: 16px;
}
.control input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.control_indicator {
  position: absolute;
  top: 0px;
  left: 0;
  height: 25px;
  width: 25px;
  background: transparent;
  border: 2px solid #9561e2;
  border-radius: 20px;
}
.control:hover input ~ .control_indicator,
.control input:focus ~ .control_indicator {
  background: #9561e2;
}

.control input:checked ~ .control_indicator {
  background: #9561e2;
}
.control:hover input:not([disabled]):checked ~ .control_indicator,
.control input:checked:focus ~ .control_indicator {
  background: #9561e2;
}
.control input:disabled ~ .control_indicator {
  background: #e6e6e6;
  opacity: 0.6;
  pointer-events: none;
}
.control_indicator:after {
  box-sizing: unset;
  content: "";
  position: absolute;
  display: none;
}
.control input:checked ~ .control_indicator:after {
  display: block;
}
.control-checkbox .control_indicator:after {
  left: 7px;
  top: 2px;
  width: 5px;
  height: 12px;
  border: solid #ffffff;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}
.control-checkbox input:disabled ~ .control_indicator:after {
  border-color: white;
}
.control-checkbox .control_indicator::before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 4.935rem;
  height: 4.5rem;
  margin-left: -1.3rem;
  margin-top: -1.3rem;
  background: #9561e2;
  border-radius: 3rem;
  opacity: 0.6;
  z-index: 99999;
  transform: scale(0);
}
@keyframes s-ripple {
  0% {
    transform: scale(0);
  }
  20% {
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
}
@keyframes s-ripple-dup {
  0% {
    transform: scale(0);
  }
  30% {
    transform: scale(1);
  }
  60% {
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
}
</style>
